import { t } from 'i18next'
import { z } from 'zod'

import { NotificationType } from '@/modules/notifications/domain/models/Notification'

export const NotificationArea = z.object({
  id: z.string(),
  notificationType: NotificationType,
  area: z.object({ id: z.string(), name: z.string() }),
  subArea: z.object({ id: z.string(), name: z.string() })
})

export const NotificationAreaDTO = z.object({
  notificationType: NotificationType.refine((value) => value !== undefined, {
    message: t('general.form.required')
  }),
  areaId: z.string().min(1, t('general.form.required')),
  subAreaId: z.string().min(1, t('general.form.required'))
})

export const EditNotificationAreaDTO = z.object({
  areaId: z.string().min(1, t('general.form.required')),
  subAreaId: z.string().min(1, t('general.form.required'))
})

export type NotificationArea = z.infer<typeof NotificationArea>
export type NotificationAreaDTO = z.infer<typeof NotificationAreaDTO>
export type EditNotificationAreaDTO = z.infer<typeof EditNotificationAreaDTO>
